import styled from "styled-components";

const SubHeading = styled.h3`
  margin: 0;
  color: ${({ theme }) => theme.colors.primary};
  font-family: ${({ theme }) => theme.fonts.impact};
  font-size: ${({ theme }) => theme.fontSizes[7]};
  font-weight: normal;
`;

export default SubHeading;
